import { Option } from '../components/shared/types';

export const SECURE_LINK_EXPIRATION_OPTIONS: Option[] = [
  { value: '1', label: '1 Hour' },
  { value: '24', label: '24 Hours' },
  { value: '48', label: '48 Hours' },
];
